import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Paths } from "../../router/Paths";
import KeyboardArrowUpIcon from "@mui/icons-material/KeyboardArrowUp";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";

const choices = [
  { label: "New Option", path: Paths.tourManagementPackageOptions },
  { label: "Option setup", path: Paths.tourManagementPackageOptionsSetup },
  {
    label: "Meeting point or pickup",
    path: Paths.tourManagementPackageOptionsMeeting,
  },
  {
    label: "Connectivity settings",
    path: Paths.tourManagementPackageOptionsConnectivity,
  },
  {
    label: "Availability and pricing",
    path: Paths.tourManagementPackageOptionsAvailability,
  },
  // { label: "Cut-off", path: Paths.tourManagementPackageOptionsCutOff },
  // { label: "Review", path: "/review" },
];

function TourManagementOptionsSidebar({ selected }: { selected: number }) {
  const navigate = useNavigate();
  const [isOpen, setIsOpen] = useState(false);

  const handleBack = () => {
    navigate(Paths.tourManagementPackageOptions);
  };

  const handleChoiceClick = (path: string) => {
    navigate(path);
  };

  const activeChoice =
    selected >= 0 && selected < choices.length
      ? choices[selected].label
      : "Select an option";

  return (
    <>
      {/*  Mobile dropdown header */}
      <div className="flex lg:hidden justify-between items-center p-3 bg-blue-500/20 rounded-t-md mt-6">
        <span className="font-bold text-black">{activeChoice}</span>
        <button onClick={() => setIsOpen(!isOpen)} className="text-gray-700">
          {isOpen ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
        </button>
      </div>
      <div
        className={`${Classname.container} lg:pt-6 ${
          !isOpen && "hidden lg:flex"
        } flex-col`}
      >
        {/* Back button */}
        <button className={Classname.button} onClick={handleBack}>
          <img
            src="/IconArrowLeft.svg"
            alt="Back"
            className={Classname.buttonIcon}
          />
          <span>Back to product</span>
        </button>

        {/* Sidebar choices */}
        {choices.map((choice, index) => (
          <div
            key={index}
            className={`flex gap-3 items-center font-bold cursor-pointer ${
              selected === index ? "text-gray-900" : "text-gray-700"
            }`}
            onClick={() => handleChoiceClick(choice.path)}
          >
            {/* Indicator */}
            <div
              className={`flex w-1 h-12 ${
                selected === index ? "bg-primary1" : "bg-gray-300"
              }`}
            ></div>
            {/* Choice label */}
            <span className={`${selected < index ? "text-gray-500" : ""}`}>
              {choice.label}
            </span>
          </div>
        ))}
      </div>
    </>
  );
}

export default TourManagementOptionsSidebar;

// Styling classes
const Classname = {
  container:
    "flex flex-col w-full lg:max-w-80 bg-blue-500/20  px-4 lg:px-6 lg:py-6flex-shrink-0",
  button:
    "w-full border border-primary1 rounded-md flex items-center gap-2 justify-center font-bold text-primary1 py-2 mb-2 cursor-pointer",
  buttonIcon: "w-6",
};
